import { Link } from "react-router-dom";
import Layout from "@/components/Layout";

export default function NotFound() {
  return (
    <Layout>
      <div className="grid min-h-[60vh] place-items-center px-5 text-center">
        <div>
          <p className="font-hand text-5xl text-terracotta">Oops…</p>
          <h1 className="mt-2 font-serif text-4xl font-bold text-forest">Page not found</h1>
          <Link to="/" className="mt-6 inline-block rounded-full bg-terracotta px-7 py-3 font-medium text-cream hover:bg-terracotta-dark">
            Back to the celebration
          </Link>
        </div>
      </div>
    </Layout>
  );
}
